import React from "react";
import { patientInitials, patientLabel } from "../model/cnoRules";
import {
    emptyStyle,
    eyebrowStyle,
    miniAvatarStyle,
    patientDetailStyle,
    patientListBodyStyle,
    patientListHeaderStyle,
    patientListItemStyle,
    patientNameStyle,
    sidebarStyle,
} from "./cnoStyles";

function PatientListItem({ patient, active, onSelect, onContextMenu }) {
    return (
        <button
            type="button"
            aria-pressed={active}
            onClick={() => onSelect(patient.id)}
            onContextMenu={event => onContextMenu(event, patient)}
            style={patientListItemStyle(active)}
        >
            <span style={miniAvatarStyle(active)}>{patientInitials(patient)}</span>
            <span style={{ minWidth: 0, flex: 1 }}>
                <strong style={patientNameStyle(active)}>{patientLabel(patient)}</strong>
                <small style={patientDetailStyle}>
                    {patient.telephone || "Téléphone non renseigné"}
                </small>
            </span>
        </button>
    );
}

export default function CnoPatientList({ patients, selectedPatientId, onSelect, onContextMenu }) {
    return (
        <aside className="cno-sidebar" style={sidebarStyle}>
            <div style={patientListHeaderStyle}>
                <span style={eyebrowStyle}>Patients</span>
                <strong style={{ color: "#172033" }}>{patients.length} fiche(s)</strong>
            </div>
            <div style={patientListBodyStyle}>
                {patients.length === 0 && <p style={emptyStyle}>Aucun patient ajouté.</p>}
                {patients.map(patient => (
                    <PatientListItem
                        key={patient.id}
                        patient={patient}
                        active={patient.id === selectedPatientId}
                        onSelect={onSelect}
                        onContextMenu={onContextMenu}
                    />
                ))}
            </div>
        </aside>
    );
}
